<form
  class="form-horizontal"
  autocomplete="off"
  #resetPasswordForm="ngForm"
  (ngSubmit)="resetPassword()"
>
  <abp-modal-header
    [title]="'ForgotMyPassword' | localize"
    (onCloseClick)="bsModalRef.hide()"
  ></abp-modal-header>
  <div class="modal-body">
    <label class="col-form-label d-flex required" for="password">
      Informe o CPF/CNPJ
    </label>
    <div class="form-group row">
      <div class="col-md-12">
        <input
          type="text"
          class="form-control"
          id="cpf"
          name="cpf"
          required
          [placeholder]="'CpfCnpj' | localize"
          maxlength="18"
          [mask]="'000.000.000-00||00.000.000/0000-00'"
          [(ngModel)]="model.cpfCnpj" #cpfModel="ngModel" #cpfEl
        />
        <abp-validation-summary
        [control]="cpfModel"
        [controlEl]="cpfEl"
      ></abp-validation-summary>
      </div>
    </div>

  </div>
  <abp-modal-footer
    [cancelDisabled]="saving"
    [saveDisabled]="!resetPasswordForm.form.valid || saving"
    (onCancelClick)="bsModalRef.hide()"
    saveLabel="OK"
  ></abp-modal-footer>
</form>
